import { LOGO_THEME } from '@lib/constants/common'
import { ImageProps } from 'next/image'
import { FastlyImage } from '@components/common/image'

type LogoType = 'main' | 'main-with-text'
type BrandLogoProps = Omit<ImageProps, 'src'> & {
  type?: LogoType
}

const getPath = (type: LogoType) => {
  switch (type) {
    case 'main':
      return `/images/logos/logos-${LOGO_THEME}/logo.svg`

    case 'main-with-text':
      return `/images/logos/logos-${LOGO_THEME}/logo-with-text.svg`
    default:
      break
  }
}
const BrandLogo = ({ type = 'main', ...props }: BrandLogoProps) => (
  <FastlyImage src={getPath(type)} {...props} />
)

export default BrandLogo
